module.exports = __webpack_public_path__ + "static/razerblast-6b4e6750a3f40334d43ac31ba232d11d.jpeg";